import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import {
  getDocumentAnalysisTemplatesOptions,
  getPersonalAnalysisRunsOptions,
} from "@/openapi/@tanstack/react-query.gen";

const searchSchema = z.object({
  tab: z.enum(["my-analysis", "templates"]).optional(),
});

export const Route = createFileRoute("/_protected/document-analysis/")({
  validateSearch: searchSchema,
  loader: ({ context: { queryClient, ...context } }) => {
    const orgId = context.user.organization?.id;

    if (!orgId) {
      throw redirect({ to: "/no-organization" });
    }

    void queryClient.query({
      ...getDocumentAnalysisTemplatesOptions({
        path: { org_id: orgId },
        query: { scope: "personal" },
      }),
      staleTime: "static",
    });
    void queryClient.query({
      ...getPersonalAnalysisRunsOptions({
        path: { org_id: orgId },
      }),
      staleTime: "static",
    });
  },
});
